/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { Routes, Route, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import Home from "./secciones/home/Home";
import ActividadesAbiertas from "./secciones/actividadesAbiertas/ActividadesAbiertas";
import ActividadAbierta from "./secciones/actividadesAbiertas/ActividadAbierta";
import AuditoriaSG from "./secciones/auditoriasSG/AuditoriaSG";
import ProcesoAuditado from "./secciones/auditoriasSG/ProcesoAuditado";
import CumplimientoAuditoria from "./secciones/auditoriasSG/Cumplimiento";
import PropuestaComercial from "./secciones/propuestaComercial/PropuestaComercial";
import ActividadesTerminadas from "./secciones/actividadesTerminadas/ActividadesTerminadas";
import Facturacion from "./secciones/facturacion/Facturacion";
import Login from "./secciones/login/Login";
import { Header, Boton, ArchivoPreviewPage } from "./shared";
import SidebarDocumentos from "./secciones/documentos/SidebarDocumentos";
import NotFound from "./secciones/notFound/NotFound";

export default function Router() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarDocumentos, setSidebarDocumentos] = useState(false);

  useEffect(() => {
    // Verificar si hay oauthtoken en la URL
    const oauthtoken = searchParams.get("oauthtoken");

    // Solo redirigir a login si hay oauthtoken y no estamos ya en /login
    if (oauthtoken && location.pathname !== "/login") {
      navigate("/login", {
        state: { oauthtoken },
      });
    }
  }, [searchParams, navigate, location.pathname]);

  return (
    <div>
      <Header
        menuUsuarioProps={{
          opcionesRol: ["administrador", "cliente"],
          manejarUsuarioProvisorio: true,
        }}
        botonera={[
          { etiqueta: "Actividades abiertas", url: "/" },
          { etiqueta: "Actividades terminadas", url: "/terminadas" },
          { etiqueta: "Facturación", url: "/facturacion" },
        ]}
      />
      <div
        css={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: "1440px",
          padding: "0px 15px",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/actividad" element={<ActividadesAbiertas />} />
          <Route path="/actividad/:pasoId" element={<ActividadAbierta />} />
          <Route path="/terminadas" element={<ActividadesTerminadas />} />
          <Route path="/facturacion" element={<Facturacion />} />
          <Route path="/auditoriasg/:auditoriaId" element={<AuditoriaSG />} />
          <Route path="/auditoriasg/:auditoriaId/proceso/:procesoAuditadoId" element={<ProcesoAuditado />} />
          <Route path="/auditoriasg/:auditoriaId/cumplimiento" element={<CumplimientoAuditoria />} />
          <Route path="/propuesta/:propuestaId" element={<PropuestaComercial />} />
          <Route path="/archivo/:hash" element={<ArchivoPreviewPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* Botón flotante de documentos */}
      <div css={{
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        zIndex: 1000,
        borderRadius: "50%",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
      }}>
        <Boton callback={() => setSidebarDocumentos(true)} azul>
          <i className="pi pi-book" css={{ color: "white" }} />
        </Boton>
      </div>

      <SidebarDocumentos
        visible={sidebarDocumentos}
        onHide={() => setSidebarDocumentos(false)}
      />
    </div>
  );
}
